
import API from "./api";
// ===== SERVICES =====

export const getServices = () => API.get("/services");

export const createService = (data) => API.post("/services", data);

export const updateService = (id, data) => API.put(`/services/${id}`, data);

export const deleteService = (id) => API.delete(`/services/${id}`);

// ===== TASKS =====

export const addTask = (serviceId, data) =>
  API.post(`/services/${serviceId}/tasks`, data);

export const updateTask = (serviceId, taskId, data) =>
  API.put(`/services/${serviceId}/tasks/${taskId}`, data);

export const deleteTask = (serviceId, taskId) =>
  API.delete(`/services/${serviceId}/tasks/${taskId}`);